(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mcm-class-collection"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mcm-maker-gallery"] && !Shopify.designMode) return;
  try {
    

(function () {
  if (window.__mcmGalleryDialogReady) return;
  window.__mcmGalleryDialogReady = true;

  document.addEventListener('click', function (event) {
    var openButton = event.target.closest(
      '[data-mcm-gallery-open]'
    );

    if (openButton) {
      var dialogId = openButton.getAttribute('aria-controls');
      var dialog = document.getElementById(dialogId);

      if (!dialog || typeof dialog.showModal !== 'function') {
        return;
      }

      dialog.__mcmReturnFocus = openButton;

      if (!dialog.open) {
        dialog.showModal();
      }

      return;
    }

    var closeButton = event.target.closest(
      '[data-mcm-gallery-close]'
    );

    if (closeButton) {
      var closeDialog = closeButton.closest(
        '[data-mcm-gallery-dialog]'
      );

      if (closeDialog && closeDialog.open) {
        closeDialog.close();
      }

      return;
    }

    var backdropDialog = event.target.closest(
      '[data-mcm-gallery-dialog]'
    );

    if (
      backdropDialog &&
      event.target === backdropDialog &&
      backdropDialog.open
    ) {
      backdropDialog.close();
    }
  });

  document.addEventListener(
    'close',
    function (event) {
      var dialog = event.target;

      if (
        !dialog.matches ||
        !dialog.matches('[data-mcm-gallery-dialog]')
      ) {
        return;
      }

      var trigger = dialog.__mcmReturnFocus;

      if (trigger && trigger.isConnected) {
        trigger.focus({ preventScroll: true });
      }

      dialog.__mcmReturnFocus = null;
    },
    true
  );
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mcm-maker-spotlights"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mcm-spotlight-layout')) {
  customElements.define('mcm-spotlight-layout', class extends HTMLElement {
    connectedCallback() {
      this.frame = 0;
      this.update = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.querySelectorAll('.mcm-spotlight__slideshow').forEach(slider => {
            const track = slider.querySelector('slideshow-slides');
            if (!track) return;
            const bounds = track.getBoundingClientRect();
            const slides = [...track.children].filter(el => el.matches('slideshow-slide'));
            const active = slides.reduce((best, el) => {
              const r = el.getBoundingClientRect();
              const distance = Math.abs(r.left + r.width / 2 - bounds.left - bounds.width / 2);
              return !best || distance < best.distance ? { el, distance } : best;
            }, null)?.el;
            const card = active?.querySelector('.mcm-spotlight__card');
            const profile = card?.querySelector('.mcm-spotlight__profile');
            if (!card || !profile || !bounds.width) return;
            const container = slider.querySelector('slideshow-container');
            const products = card.querySelector('.mcm-spotlight__products');
            const items = products ? [...products.querySelectorAll(':scope > a')] : [];
            const cardRect = card.getBoundingClientRect();
            const contentBottom = items.length ? Math.max(...items.map(el => el.getBoundingClientRect().bottom)) : cardRect.bottom;
            const height = Math.ceil(contentBottom - cardRect.top + 6);
            const upper = [...profile.querySelectorAll('.mcm-spotlight__media img, .mcm-spotlight__copy')];
            const upperBottom = upper.length ? Math.max(...upper.map(el => el.getBoundingClientRect().bottom)) : profile.getBoundingClientRect().bottom - 44;
            const firstImage = products?.querySelector('img');
            const lowerTop = firstImage ? firstImage.getBoundingClientRect().top : profile.getBoundingClientRect().bottom;
            const arrowTop = Math.ceil((upperBottom + lowerTop) / 2 - container.getBoundingClientRect().top - 22);
            if (slider.style.getPropertyValue('--mcm-active-card-height') !== `${height}px`)
              slider.style.setProperty('--mcm-active-card-height', `${height}px`);
            slider.style.setProperty('--mcm-arrow-top', `${arrowTop}px`);
          });
        });
      };
      this.addEventListener('scroll', this.update, true);
      this.addEventListener('load', this.update, true);
      this.resize = new ResizeObserver(this.update);
      this.resize.observe(this);
      this.querySelectorAll('.mcm-spotlight__card').forEach(el => this.resize.observe(el));
      this.querySelectorAll('.mcm-spotlight__profile, .mcm-spotlight__products').forEach(el => this.resize.observe(el));
      this.update();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.resize?.disconnect();
      this.removeEventListener('scroll', this.update, true);
      this.removeEventListener('load', this.update, true);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mcm-review-form-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mcm-review-form-tabs')) {
    customElements.define('mcm-review-form-tabs', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.tabs = [...this.querySelectorAll('[data-review-tab]')];
        this.panels = [...this.querySelectorAll('[data-review-panel]')];
        const list = this.querySelector('.mcm-review-tabs__list');
        if (!this.tabs.length) return;
        list.hidden = false;
        list.setAttribute('role', 'tablist');
        this.tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          this.panels[index].setAttribute('role', 'tabpanel');
          tab.addEventListener('click', () => this.select(index), options);
          tab.addEventListener('keydown', event => {
            let target;
            if (event.key === 'ArrowRight') target = (index + 1) % this.tabs.length;
            if (event.key === 'ArrowLeft') target = (index + this.tabs.length - 1) % this.tabs.length;
            if (event.key === 'Home') target = 0;
            if (event.key === 'End') target = this.tabs.length - 1;
            if (target === undefined) return;
            event.preventDefault();
            this.select(target);
            this.tabs[target].focus();
          }, options);
        });
        this.select(0);
        document.addEventListener('shopify:block:select', event => {
          const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail?.blockId);
          if (index >= 0) this.select(index);
        }, options);
      }
      select(index) {
        this.tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          this.panels[i].hidden = i !== index;
        });
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.abort = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
